import React, { Component } from 'react';
import * as Sentry from '@sentry/react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license';

//import css
import './App.css';
import './style/notam.scss';
import './style/wxt.scss';
import './style/wxg.scss';
import './style/fltdata/flt-data.scss';
import './style/fltdata/fourth-row-data.scss';
import './style/fltdata/calculation-time.scss';
import './style/fltdata/alternate-route.scss';
import './style/select-fp.scss';
import './style/login.scss';
import './style/logout.scss';
import './style/crew-msg.scss';
import './style/flt-plan.scss';
import './style/flightplannew.scss';
import './style/cabin-crew-page.scss';
import './style/topinfoline.scss';
import './style/modal.scss';
import './style/airport-modal.scss';

// Import worker dynamically for PDF viewing
import 'pdfjs-dist/build/pdf.worker.min.mjs';

import { Mainapp } from './Mainapp';
import Login from './pages/Login';
import { ErrorBoundary, HandleCache } from './components';
import { DataServiceProvider } from './contexts';
import OfflineReloadGuard from './components/OfflineReloadGuard';

// Initialize Sentry with simple configuration
// Sentry.init({
//   dsn: 'https://ff6846ee6d8f317a706db5b47b7b7404@o4509117202694144.ingest.de.sentry.io/4509145789890640',
//   environment: process.env.NODE_ENV,
//   tracesSampleRate: 0.1,
//   sendDefaultPii: true,
//   integrations: [Sentry.replayIntegration()],
//   // Session Replay
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
//   ignoreErrors: ['UnknownError: Database deleted by request of the user'],
// });

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_PRO_LICENCE_KEY); // Norwegian owns this key

// Main app component (loaded in when user is authenticated)
function mainapp({ match }) {
  localStorage.setItem('empno', match.params.usrid);

  let empno = localStorage.getItem('empno');

  return (
    <div style={{ height: '100%' }}>
      <Mainapp empnumber={match.params.usrid} />
    </div>
  );
}

// Main app component (loaded in when user is authenticated) and the user id is not in the url
function mainappNoUserid({ match }) {
  let empno = localStorage.getItem('empno');

  return (
    <div style={{ height: '100%' }}>
      <Mainapp empnumber={empno} />
    </div>
  );
}

// Private route (used to check if user is authenticated), if not authenticated, redirect to login page
function PrivateRoute({
  component: Component,
  authenticated,
  employeeNumber,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) =>
        authenticated ? (
          <ErrorBoundary
            customErrorMessage={'An error occured in the Mainapp.js file'}
          >
            <DataServiceProvider employeeNumber={employeeNumber}>
              <Component {...props} />
            </DataServiceProvider>
          </ErrorBoundary>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      isAuthenticated: 'not set',
      employeeNumber: '',
    };
    this.authenticate = this.authenticate.bind(this);
    this.isAuth = this.isAuth.bind(this);
    this.componentWillMount = this.componentWillMount.bind(this);
  }

  // Set state to authenticated
  authenticate() {
    this.setState({ isAuthenticated: true });
    alert('auth now');
  }

  // Request to server to check if user is authenticated
  isAuth() {
    fetch(process.env.REACT_APP_SERVER_URL + '/isAuth', {
      credentials: 'include',
    })
      .then((res) => res.json())
      .then((responseData) => {
        this.setState({
          isAuthenticated: responseData[0].authBool,
          employeeNumber: responseData[0].empno,
        });
        return responseData[0].authBool;
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.log(error);
        this.setState({
          isAuthenticated: false,
        });
      });
  }

  // Check if user is authenticated when app first mounts
  componentWillMount() {
    // If user is offline, skip login
    if (navigator.onLine) {
      this.isAuth();
    } else {
      this.setState({
        isAuthenticated: true,
      });
    }
  }

  render() {
    return (
      // <HandleCache> Wait for removal until we confirm that it works
      <OfflineReloadGuard>
        <Sentry.ErrorBoundary>
          <Router>
            <Switch>
              <Route
                path='/login'
                component={() => <Login authenticate={this.authenticate} />}
                authenticate={this.authenticate}
              />
              <PrivateRoute
                path='/user/:usrid'
                component={mainapp}
                authenticated={this.state.isAuthenticated}
                employeeNumber={this.state.employeeNumber}
              />
              <PrivateRoute
                path='/*'
                component={mainappNoUserid}
                authenticated={this.state.isAuthenticated}
                employeeNumber={this.state.employeeNumber}
              />
            </Switch>
          </Router>
        </Sentry.ErrorBoundary>
      </OfflineReloadGuard>
      // </HandleCache>
    );
  }
}

export default Sentry.withProfiler(App, { name: 'front' });

